__turbopack_context__.v({
  "placeholder": "Avatar-module__NnTfhW__placeholder",
  "root": "Avatar-module__NnTfhW__root",
});
